import { env } from "@/env"
import { PlainDate } from "./date"
import { ScatterChartIcon } from "lucide-react"
import { PRICE_MONTH_RATE } from "@/constants/prices"

export const calculateReportFee = (monthsCount: number) => {
	if (monthsCount === 0) return 0

	const fee = Math.min(monthsCount * PRICE_MONTH_RATE, 50)
	return fee - 0.01
}

export const monthsBetween = (startDate?: PlainDate, endDate?: PlainDate) => {
	if (!startDate || !endDate) return 0

	const days = Math.abs(
		startDate.toTemporal().until(endDate.toTemporal(), {
			largestUnit: "days",
		}).days
	)

	if (days > 366) return Math.ceil(days / 30)

	if (days <= 0) return 0

	if (days > 310) return 12

	return Math.ceil(days / 31)
}
